// extracted by mini-css-extract-plugin
export default {"calendarSectionNavigation":"calendarNavigation_calendarSectionNavigation__rCJjl","arrow":"calendarNavigation_arrow__jupPX","arrowLeft":"calendarNavigation_arrowLeft__sYpaA"};